export function getLocalStorage(key) {
  return JSON.parse(localStorage.getItem(key));
}

export function setLocalStorage(key, data) {
  return localStorage.setItem(key, JSON.stringify(data));
}

export function removeLocalStorage(key) {
  return localStorage.removeItem(key);
}

export function getSessionStorage(key) {
  return JSON.parse(sessionStorage.getItem(key));
}

export function setSessionStorage(key, data) {
  return sessionStorage.setItem(key, JSON.stringify(data));
}

export function removeSessionStorage(key) {
  return sessionStorage.removeItem(key);
}

export function updateLocalStorage(key, data) {
  let obj = JSON.parse(localStorage.getItem(key) || null) || {}

  localStorage.setItem(key, JSON.stringify({...obj, ...data}));
}
// 设置搜索历史
export function searchHistory(key, data) {
  return localStorage.setItem(key, JSON.stringify(data));
}
// 获取搜索历史
export function GetHistory(key) {
  return JSON.parse(localStorage.getItem(key));
}
